export default __webpack_public_path__ + "static/media/logo.cceca987.webp";